@if ((data$ | async); as data) {
<tux-page-header
  [pageTitle]="'Data Studio - ' + data.instance?.name"
  [breadcrumbs]="[
    { path: '', title: 'Home' },
    { path: '/application-manager', title: 'Current Customers' },
    {
      path: '/application-manager/' + data.customer?.customerId,
      title: data.customer?.name || 'Customer'
    },
    { title: 'Data Studio Instance' }
  ]"
  [subMenu]="false"
>
  <tux-page-header-buttons>
    <p-button
      label="Decommission"
      [outlined]="true"
      [severity]="'danger'"
      styleClass="surface-border font-medium"
      [disabled]="data.instance"
      (click)="data.instance && decommissionInstance(data.instance)"
    ></p-button>
    <p-button
      type="primary"
      label="Change Status"
      styleClass="font-medium"
      (click)="changeInstanceStatus()"
    ></p-button>
  </tux-page-header-buttons>

  <div ngProjectAs="tux-metadata">
    <div class="flex gap-4 w-full">
      <div class="flex gap-2">
        <span class="font-medium">BF_Org UUID</span
        ><span>{{ data.instance?.bfOrgUuid || '-' }}</span>
      </div>
      <div class="flex gap-2">
        <span class="font-medium">BF_ORG ID</span
        ><span>{{ data.instance?.bfOrgId || '-' }}</span>
      </div>
      <div class="flex gap-2">
        <span class="font-medium">List Based</span
        ><span>{{ data.instance?.listBased || '-' }}</span>
      </div>
      <div class="flex gap-2">
        <span class="font-medium">CRM Type</span
        ><span>{{ data.instance?.crmType || '-' }}</span>
      </div>
    </div>
  </div>
</tux-page-header>

<!-- Visitor Tracking-->
<p-panel [toggleable]="true" class="block panel-padding w-8 pb-4">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between p-2 w-full">
      <label class="font-bold w-full" for="visitor-tracking-switch">
        Visitor Tracking
      </label>
      <p-toggleSwitch
        inputId="visitor-tracking-switch"
        [formControl]="
          featureConfigs.controls.webConfiguration.controls.enabled
        "
      ></p-toggleSwitch>
    </div>
  </ng-template>

  <div class="flex flex-column gap-1">
    <span class="pb-2"
      >This script allows DemandScience to track website visitors for this Data
      Studio Instance. Visitors will be tracked in the domains whitelisted
      below.</span
    >

    <!-- Visitor Tracking Script: Empty when nothing ever configured -->
    <div class="col field flex flex-column">
      <label class="font-medium" for="visitor-tracking-script"
        >Visitor Tracking Script</label
      >
      <p id="visitor-tracking-script" class="script-tag">
        {{ visitorTrackingScript$ | async }}
      </p>
    </div>

    <!-- Not sure if this bit is needed, keeping commented out incase requested in the future -->
    <!-- @if(data.instance?.name){
      <div class="col field flex flex-column">
        <label class="font-medium"
          >Whitelisted Domains</label
        >
      <div class="mt-2">
        <span class="surface-200 p-2 border-round"
          >Data Studio - {{ data.instance?.name }}</span
        >
      </div>
    </div>
    } -->

    <!-- Whitelisted Domains -->
    <div class="col field flex flex-column">
      <label class="font-medium" for="whitelisted-domains-input"
        >Whitelisted Domains</label
      >
      <p-autoComplete
        multiple
        [typeahead]="false"
        [formControl]="
          featureConfigs.controls.webConfiguration.controls.whitelistedDomains
        "
        separator=","
        inputId="whitelisted-domains-input"
        placeholder="Hint: domain1, domain2, domain3"
      >
      </p-autoComplete>
    </div>

    <div class="flex justify-content-end">
      <p-button
        [disabled]="featureConfigs.controls.webConfiguration.pristine"
        styleClass="p-2"
        label="Save Changes"
        (onClick)="updateVisitorTrackingConfig()"
      ></p-button>
    </div>
  </div>
</p-panel>
<!-- Topic Limits -->
<p-panel [toggleable]="true" class="block panel-padding w-8 pb-4">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between p-2 w-full">
      <span class="font-bold"> Topic Limits </span>
    </div>
  </ng-template>

  <div class="flex flex-column gap-1 pb-3">
    <span class="pb-2">Configure intent topic limits for this instance.</span>

    <label for="topic-limits-dropdown" class="w-full font-medium"
      >Intent Topic Limit</label
    >
    <p-dropdown
      [options]="intentTopicLimitOptions"
      [formControl]="
        featureConfigs.controls.topicLimits.controls.intentTopicLimit
      "
      [style]="{ width: '50%' }"
      inputId="topic-limits-dropdown"
    ></p-dropdown>
  </div>

  <div class="flex justify-content-end">
    <p-button
      [disabled]="featureConfigs.controls.topicLimits.pristine"
      styleClass="p-2"
      label="Save Changes"
      (onClick)="
        updateDataStudioConfig({
          bfOrgUuid: data.instance?.bfOrgUuid,
          intentTopic: {
            bfOrgUuid: data.instance?.bfOrgUuid,
            trackedTopicsLimit:
              featureConfigs.controls.topicLimits.value.intentTopicLimit
          }
        })
      "
    ></p-button>
  </div>
</p-panel>

<!-- Prospect Engine -->
<p-panel [toggleable]="true" class="block panel-padding w-8 pb-4">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between p-2 w-full">
      <label class="font-bold w-full" for="prospect-engine-switch">
        Prospect Engine
      </label>
      <p-toggleSwitch
        inputId="prospect-engine-switch"
        [formControl]="featureConfigs.controls.prospectEngine.controls.enabled"
      ></p-toggleSwitch>
    </div>
  </ng-template>

  <div class="flex flex-column gap-1">
    <span class="pb-2"
      >Enter the Prospect Engine contract start date and record limit to set the
      annual sync limit for company and contact records.</span
    >
    <div class="formgrid grid gap-4">
      <div class="col field flex flex-column">
        <label class="font-medium" for="syncRecordLimit"
          >Sync Record Limit</label
        >
        <p-inputNumber
          [formControl]="
            featureConfigs.controls.prospectEngine.controls.maxRecords
          "
          inputId="syncRecordLimit"
          styleClass="w-full"
        ></p-inputNumber>
      </div>
      <div class="col field flex flex-column">
        <label class="font-medium" for="contractStartDate"
          >Contract Start Date (Sync Limit Reset)</label
        >
        <p-datepicker
          [formControl]="
            featureConfigs.controls.prospectEngine.controls.renewDate
          "
          inputId="contractStartDate"
          styleClass="w-full"
          [showIcon]="true"
        ></p-datepicker>
      </div>
    </div>
    <div class="flex justify-content-end">
      <p-button
        [disabled]="featureConfigs.controls.prospectEngine.pristine"
        styleClass="p-2"
        label="Save Changes"
        (onClick)="
          updateDataStudioConfig({
            bfOrgUuid: data.instance?.bfOrgUuid,
            prospectEngine: featureConfigs.controls.prospectEngine.value
          })
        "
      ></p-button>
    </div>
  </div>
</p-panel>

<!-- Measurement Studio Reports -->
<p-panel [toggleable]="true" class="block panel-padding w-8 pb-4">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between p-2 w-full">
      <span class="font-bold"> Measurement Studio Reports </span>
    </div>
  </ng-template>

  <div class="flex flex-column gap-1 pb-3">
    <span class="pb-2"
      >Measurement studio reports, press 'Save Changes' to apply your
      changes.</span
    >

    @for(report of
    featureConfigs.controls.measureStudio.controls.reports.controls | keyvalue;
    track report.key){
    <span
      class="flex gap-1 justify-content-between border-bottom hover:surface-200"
    >
      <label for="report-toggle-{{ report.key }}" class="w-full font-medium">{{
        displayNameMap[report.key] || report.key
      }}</label>
      <p-toggleSwitch
        inputId="report-toggle-{{ report.key }}"
        [formControl]="report.value"
      ></p-toggleSwitch>
    </span>
    }
  </div>

  <div class="flex justify-content-end">
    <p-button
      [disabled]="featureConfigs.controls.measureStudio.pristine"
      styleClass="p-2"
      label="Save Changes"
      (onClick)="
        updateDataStudioConfig({
          bfOrgUuid: data.instance?.bfOrgUuid,
          measureStudio: featureConfigs.controls.measureStudio.value
        })
      "
    ></p-button>
  </div>
</p-panel>

<!-- Central Reports -->
<p-panel [toggleable]="true" class="block panel-padding w-8 pb-4">
  <ng-template pTemplate="header">
    <div class="flex align-items-center justify-content-between p-2 w-full">
      <span class="font-bold"> Central Reports </span>
      <p-toggleSwitch
        inputId="central-switch"
        [formControl]="featureConfigs.controls.central.controls.enabled"
      ></p-toggleSwitch>
    </div>
  </ng-template>

  <div class="flex flex-column gap-1 pb-3">
    <span class="pb-2"
      >Central Configuration, press 'Save Changes' to apply your changes.</span
    >

    @for(report of featureConfigs.controls.central.controls.reports.controls |
    keyvalue; track report.key){
    <span
      class="flex gap-1 justify-content-between border-bottom hover:surface-200"
    >
      <label for="report-toggle-{{ report.key }}" class="w-full font-medium">{{
        displayNameMap[report.key] || report.key
      }}</label>
      <p-toggleSwitch
        inputId="report-toggle-{{ report.key }}"
        [formControl]="report.value"
      ></p-toggleSwitch>
    </span>
    }
    <br />
    <label for="packaging-dropdown" class="w-full font-medium"
      >Central Packaging</label
    >
    <p-dropdown
      [options]="CENTRAL_PACKAGING_OPTIONS"
      [formControl]="featureConfigs.controls.central.controls.packaging"
      [style]="{ width: '50%' }"
      inputId="packaging-dropdown"
    ></p-dropdown>
  </div>

  <div class="flex justify-content-end">
    <p-button
      [disabled]="featureConfigs.controls.central.pristine"
      styleClass="p-2"
      label="Save Changes"
      (onClick)="
        updateDataStudioConfig({
          bfOrgUuid: data.instance?.bfOrgUuid,
          central: featureConfigs.controls.central.value
        })
      "
    ></p-button>
  </div>
</p-panel>
}
